exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".theme_2fR3w1PNBxC88jtp0AJcUa .section_2NWS1P4ZgppKzQnUVSNWo- {\n  float: left;\n  clear: both;\n  margin-bottom: 15px;\n}\n\n.theme_2fR3w1PNBxC88jtp0AJcUa .pageTitle_1DcxMn4aKW5ULr1pLQLPYb {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n\n.theme_2fR3w1PNBxC88jtp0AJcUa .pageDescription_2G8ZtjV4mBvBGcxPIEwbnV {\n  font-size: 15px;\n  font-weight: 300;\n}\n\n.theme_2fR3w1PNBxC88jtp0AJcUa .button_3SlSerOf7SLeTB87_XHv6j {\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"theme": "theme_2fR3w1PNBxC88jtp0AJcUa",
	"section": "section_2NWS1P4ZgppKzQnUVSNWo-",
	"pageTitle": "pageTitle_1DcxMn4aKW5ULr1pLQLPYb",
	"pageDescription": "pageDescription_2G8ZtjV4mBvBGcxPIEwbnV",
	"button": "button_3SlSerOf7SLeTB87_XHv6j"
};